import { Box, Grid, List, ListItem, ListItemText, Stack, Typography } from '@mui/material';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllPropertyGroupsConfigs, selectPropertyGroupDetailsState, selectSpecificPropertyGroupConfigs } from '../../shared/sagas/propertyGroups/propertyGroupsSlice';
import PropertyGroupConfiguration from './propertyGroupConfiguration';
import SpinnerWithNoConfirmation from '../../shared/Modal/spinnerWithNoConfirmation';
import { useEffect } from 'react';

export default function PropertyGroups(props: {}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { url } = useRouteMatch();
  const { uuid: propertyGroupIdParam } = useParams<{ uuid: string }>();
  useEffect(() => {
    if (shouldRefreshAllPropertyGroupConfigs) dispatch(getAllPropertyGroupsConfigs());
  }, []);

  const { propertyGroups, isFetchingPropertyGroups, isFetchingPropertyGroupsSuccess, isFetchingPropertyGroupsFailed, isFetchingAllPropertyGroupConfigs, isFetchingAllPropertyGroupConfigsSuccess, isFetchingAllPropertyGroupConfigsFailed, shouldRefreshAllPropertyGroupConfigs } = useSelector(selectPropertyGroupDetailsState);

  if (!propertyGroupIdParam && isFetchingPropertyGroupsSuccess && propertyGroups?.length===1) {;
    history.push(`${url}/${propertyGroups?.[0].Uuid}`);
  }

  const randDarkHexColor = () => {
    //borrowed and updated from online.
    const lum = -0.25;
    let hex = String('#' + Math.random().toString(16).slice(2, 8).toUpperCase()).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }

    let rgb = '#';

    for (let i = 0; i < 3; i++) {
      const hexColorInt = parseInt(hex.slice(i * 2, i * 2 + 2), 16); //get the base 16 int val of this 2digit hex section
      const hexColor2Char = Math.round(Math.min(Math.max(0, hexColorInt + hexColorInt * lum), 255)).toString(16); //c is a string right here
      rgb += ('00' + hexColor2Char).slice(hexColor2Char.length);
    }

    return rgb;
  };

  return (
    <>
      {!propertyGroupIdParam && isFetchingPropertyGroupsSuccess ? (
        // main page
        <Grid container spacing={2}>
          <Grid xs={12} item>
            <Typography sx={{ margin: '2% 0 16px', fontWeight: '800', fontSize: '18px' }}>Property Groups</Typography>
          </Grid>
          {propertyGroups.map((pg) => (
            <Grid key={pg.Uuid} sm={12} md={6} lg={4} item>
              <PropertyGroupTile {...{ uuid: pg.Uuid, options: [`Property Count: ${pg.PropertyCount}`], header: pg.Description, headerColorHex: pg.DisplayColorCode ?? randDarkHexColor() }} />
            </Grid>
          ))}
        </Grid>
      ) : !!propertyGroupIdParam && isFetchingAllPropertyGroupConfigsSuccess ? (
        <PropertyGroupConfiguration Uuid={propertyGroupIdParam} />
      ) : isFetchingPropertyGroups || isFetchingAllPropertyGroupConfigs ? (
        <Stack
          justifyContent="center"
          alignItems="center"
          style={{
            height: '1100px',
          }}
        >
          <SpinnerWithNoConfirmation />
        </Stack>
      ) : isFetchingAllPropertyGroupConfigsFailed || isFetchingPropertyGroupsFailed ? (
        <>There was an error loading the information. Please try again.</>
      ) : (
        <></>
      )}
    </>
  );
}

function PropertyGroupTile(props: { uuid: string; header: string; options: string[]; headerColorHex?: string }) {
  const history = useHistory();
  const { url } = useRouteMatch();
  const dispatch = useDispatch();
  const goToPage = (propertyGroupUuid: string) => {
    dispatch({
      type: selectSpecificPropertyGroupConfigs.type,
      payload: {
        propertyGroupUuid: propertyGroupUuid,
      },
    });
    history.push(`${url}/${propertyGroupUuid}`);
  };

  return (
    <>
      <Box onClick={() => goToPage(props.uuid)} sx={{ cursor: 'pointer', boxSizing: 'border-box', borderRadius: '24px', overflow: 'hidden', width: '412px', height: '217px', margin: '16px 2% 16px 0' }}>
        <Stack direction={'row'} sx={{ background: props.headerColorHex, padding: '14px 0 12px 16px', color: '#fff' }}>
          <Typography sx={{ width: '90%', textAlign: 'left', fontWeight: '800' }}>{props.header}</Typography>
        </Stack>
        <List dense={true} sx={{ background: '#fff', height: 'inherit', paddingLeft: '2%' }}>
          {props.options.map((option) => {
            return (
              <ListItem key={option}>
                <ListItemText primary={option} />
              </ListItem>
            );
          })}
        </List>
      </Box>
    </>
  );
}
